import { createContext, useMemo } from 'react';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { useLoadGeneratedQuery } from './useLoadGeneratedQuery';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SearchQueryStoreContext = /*#__PURE__*/createContext(null);
export const GenerateSearchQueryProvider = ({
  children,
  searchQuery
}) => {
  const {
    loading,
    data
  } = useLoadGeneratedQuery(searchQuery);
  const store = useMemo(() => {
    if (!loading && data) {
      return {
        query: data
      };
    }
    return null;
  }, [loading, data]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [loading && /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    }), !loading && store && /*#__PURE__*/_jsx(SearchQueryStoreContext.Provider, {
      value: store,
      children: children
    })]
  });
};